<template>
    <div ref="info" class="page-warpper flex flex-direction">
        <header-modular :url="web_emof_home"></header-modular>
        <div class="container  flex-sub">
            <div class="page-container flex flex-direction flex-sub">
                <div class="content-container flex-sub">
                    <div class="content flex-sub">
                        <div class="flex align-center justify-between">
                            <div class="page-title">版本更新</div>
                            <div class="page-back" @click="$router.go(-1)">返回</div>
                        </div>
                        <empty v-if="lists.length === 0" :type="0"/>
                        <div class="flex flex-direction">
                            <div v-for="(item,index) in lists" :key="index" class="item-notice flex align-center justify-between" @click="showDetail(item.id)">
                                <div class="title">{{ item.title }}</div>
                                <div class="time">{{ item.create_time }}</div>
                            </div>
                        </div>
                        <el-pagination
                            v-if="lists.length>0"
                            :current-page.sync="page"
                            :page-size="limit"
                            :total="total"
                            background
                            class="page-all margin-top"
                            layout="prev, pager, next, jumper"
                            @current-change="init">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <footer-modular></footer-modular>
        <version-detail-dialog :detailDialogVisible="detailDialogVisible" :nid="cur_nid"
                               @watchState="watchState"></version-detail-dialog>
    </div>
</template>

<script>
import HeaderModular from "./common/headerPage";
import FooterModular from "./common/footerPage";
import {urlStr} from '@/config'
import {getVersionList} from "@/api/login";
import {zhDate} from "@/utils/utils";
import VersionDetailDialog from "@/components/VersionDetailDialog";

export default {
    name: "VersionName",
    components: {
        VersionDetailDialog,
        FooterModular, HeaderModular
    },
    data() {
        return {
            web_emof_home: urlStr,
            lists: [],
            page: 1,
            limit: 10,
            total: 0,
            cur_nid: 0,
            detailDialogVisible: false,
        }
    },
    created() {
        this.init()
    },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
    methods: {
        async init() {
            let _data = await getVersionList(this.user.mid, this.page, this.limit)

            if(_data.status === 200) {
              console.log( _data.data)
              _data.data.data.map(item => {
                item.create_time = zhDate(item.create_time * 1000)
              })
              this.lists = _data.data.data
              this.total = _data.data.total
            }
        },
        showDetail(id) {
            this.cur_nid = id
            this.detailDialogVisible = true;
        },
        watchState() {
            this.detailDialogVisible = false;
        },
    }

}
</script>

<style lang="scss" scoped>
.page-warpper {
    height: 100vh;
    background: #ebeff5;

    .container {
        display: flex;
        flex-direction: column;
        width: 1200px;
        margin: 0 auto;
      flex: 1;
      height: 0;

        .page-container {
            margin: 15px 0;
          flex: 1;
          height: 0;

            .content-container {
                display: flex;
                flex-direction: column;
                background-color: #0a2240;
                border-radius: 10px;
                padding: 15px;
                margin-left: 10px;
              flex: 1;
              height: 0;
                .content {
                    display: flex;
                    flex-direction: column;
                    flex: 1;
                    background-color: #ffffff;
                    border-radius: 10px;
                    padding: 30px;

                    .item-notice {
                        width: 100%;
                        height: 70px;
                        cursor: pointer;
                        .title {
                            font-size: 20px;
                            font-weight: bold;
                            color: #0a2240;
                        }

                        .time {
                            font-size: 16px;
                            color: #666666;
                        }

                        border-bottom: 1px solid #eeeeee;
                    }

                }
            }
        }

    }
}
</style>
